import { datadogRum } from '@datadog/browser-rum';
import { datadogLogs } from '@datadog/browser-logs';
import {
  DATADOG_RUM_ENABLED,
  DATADOG_RUM_APPLICATION_ID,
  DATADOG_RUM_CLIENT_TOKEN,
  DATADOG_RUM_SITE,
  DATADOG_RUM_ENV,
  DATADOG_RUM_VERSION,
  DATADOG_RUM_PROXY_URL,
  CORE_API,
  UPLOADS_API,
  LEGACY_API_URL,
  CORE_LEGACY_API_URL,
  SCREENINGS_API,
  DATADOG_LOGS_ENABLED,
} from '../env.config';

let rumInitialized = false;
let logsInitialized = false;

function buildDatadogRumConfig() {
  const config = {
    applicationId: DATADOG_RUM_APPLICATION_ID,
    clientToken: DATADOG_RUM_CLIENT_TOKEN,
    site: DATADOG_RUM_SITE,
    service: 'uniteus-widgets',
    env: DATADOG_RUM_ENV,
    version: DATADOG_RUM_VERSION || undefined,
    sessionSampleRate: 100,
    sessionReplaySampleRate: 100,
    trackUserInteractions: false,
    trackResources: true,
    trackLongTasks: true,
    defaultPrivacyLevel: 'mask-user-input',
    allowedTracingUrls: [
      CORE_API,
      UPLOADS_API,
      LEGACY_API_URL,
      CORE_LEGACY_API_URL,
      SCREENINGS_API,
      DATADOG_RUM_PROXY_URL,
    ].filter(Boolean),
  };

  if (DATADOG_RUM_PROXY_URL) {
    config.proxy = (options) => (
      `${DATADOG_RUM_PROXY_URL}/${options.path}?${options.parameters}`
    );
  }

  return config;
}

export function initializeDatadogRum() {
  if (
    rumInitialized
    || !DATADOG_RUM_ENABLED
    || !DATADOG_RUM_APPLICATION_ID
    || !DATADOG_RUM_CLIENT_TOKEN
  ) {
    return;
  }

  datadogRum.init(buildDatadogRumConfig());

  rumInitialized = true;
}

export function initializeDatadogLogs() {
  if (
    logsInitialized
    || !DATADOG_LOGS_ENABLED
    || !DATADOG_RUM_APPLICATION_ID
    || !DATADOG_RUM_CLIENT_TOKEN
  ) {
    return;
  }

  const config = {
    applicationId: DATADOG_RUM_APPLICATION_ID,
    clientToken: DATADOG_RUM_CLIENT_TOKEN,
    site: DATADOG_RUM_SITE,
    service: 'uniteus-widgets',
    env: DATADOG_RUM_ENV,
    version: DATADOG_RUM_VERSION || undefined,
    sessionSampleRate: 100,
    defaultPrivacyLevel: 'mask-user-input',
    forwardConsoleLogs: ['error', 'warn'],
    allowedTracingUrls: [
      CORE_API,
      UPLOADS_API,
      LEGACY_API_URL,
      CORE_LEGACY_API_URL,
      SCREENINGS_API,
      DATADOG_RUM_PROXY_URL,
    ].filter(Boolean),
  };

  if (DATADOG_RUM_PROXY_URL) {
    config.proxy = (options) => (
      `${DATADOG_RUM_PROXY_URL}/${options.path}?${options.parameters}`
    );
  }

  datadogLogs.init(config);
  window.datadogLogs = datadogLogs;
  logsInitialized = true;
}
